export default "__VITE_ASSET__pUrA2pwK__"